/**
 *
 * App
 *
 * This component is the skeleton around the actual pages, and should only
 * contain code that should be seen on all pages. (e.g. navigation bar)
 */

import React, { Suspense } from 'react';
import Configurator from '../Configurator';
import GlobalStyle from 'global-styles';
// eslint-disable-next-line no-restricted-imports
import { ThemeProvider } from 'styled-components';
import styled from 'styled-components/macro';
import { theme } from 'styles/styled-components';
import GlobalShortcutManager from 'containers/Shortcut/GlobalShortCutManager';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useDispatch } from 'react-redux';

export default function App() {
  return (
    <GlobalShortcutManager>
      <ThemeProvider theme={theme}>
        <StyledContainer>
          <div className="flex flex-col">
            <Suspense fallback={<div>Loading</div>}>
              <Configurator />
              <GlobalStyle />
              {/*{!isMobile && (
                <small>
                  You are running this application in{' '}
                  <b>{process.env.NODE_ENV}</b> environment.
                </small>
              )}*/}
            </Suspense>
          </div>
        </StyledContainer>
      </ThemeProvider>
      <ToastContainer
        position="top-center"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        draggable={false}
        pauseOnHover={false}
      />
    </GlobalShortcutManager>
  );
}

const StyledContainer = styled.div`
  outline: none;
  width: 100%;
  //height: calc(100vh - 70px);

  @media (min-width: 1024px) {
    max-width: 1024px;
    margin-left: auto;
    margin-right: auto;
  }

  @media (min-width: 1280px) {
    max-width: 1280px;
  }
`;
